import { EscalationWebhook, EscalationWebhookPayload, EscalationWebhookTestResult } from "@/types/agent/escalation-webhook";
import { ApiService } from "../api/ApiService";

class EscalationWebhookService {
  async get(agentId: string): Promise<EscalationWebhook | null> {
    const res = await ApiService.invoke<any>({
      resource: "escalation-webhooks",
      action: "get",
      data: { agentId },
    });
    return res?.data ?? res;
  }

  async upsert(agentId: string, payload: EscalationWebhookPayload): Promise<EscalationWebhook> {
    const res = await ApiService.invoke<any>({
      resource: "escalation-webhooks",
      action: "upsert",
      data: { agentId, ...payload },
    });
    return res?.data ?? res;
  }

  async delete(agentId: string): Promise<void> {
    await ApiService.invoke({
      resource: "escalation-webhooks",
      action: "delete",
      data: { agentId },
    });
  }

  async test(agentId: string): Promise<EscalationWebhookTestResult> {
    const res = await ApiService.invoke<any>({
      resource: "escalation-webhooks",
      action: "test",
      data: { agentId },
    });
    return res?.data ?? res;
  }
}

export const escalationWebhookService = new EscalationWebhookService();
